import React, {memo} from "react";
import { Trans } from "@lingui/macro";
import AmountTd from "../../../../Table/Common/AmountTd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import BukkuTooltip from "../../../../Tooltip";
import { LockIcon } from "../../../../Access/common/LockIcon";

function Cost(props) {
    const { record, hideInventoryCosting } = props;

    const { base_cost_amount: amount, is_transferred, transfer_transaction_number } = record;

    if (hideInventoryCosting)
        return (<LockIcon className="grey" />);

    if (amount === '' || amount === undefined || amount === null)
        return null;

    const renderTransferredFrom = () => (
        <BukkuTooltip
            title={
                <Trans>
                    Transferred from&nbsp;
                    {' '}
                    {transfer_transaction_number}
                </Trans>
            }
        >
            <ExclamationCircleOutlined />
        </BukkuTooltip>
    );

    return (
        <>
            {is_transferred && renderTransferredFrom()}
            <AmountTd amount={amount} />
        </>
    );
}

export default memo(Cost);
